import React from "react";
import { FaAndroid, FaGlobe, FaShoppingCart, FaUserTie } from "react-icons/fa";
import { MdSettings } from "react-icons/md";
import { TagComponent } from "../Tabs";

const Settings = () => {


  return (
    <div className="bg-white shadow-lg rounded-xl p-6 sm:p-8  mx-auto border border-gray-200" id="top">

      <div className="flex items-center mb-6 border-b pb-4 border-gray-200">
        <MdSettings className="text-4xl text-theme-logo-color mr-3" />
        <h1 className="text-2xl sm:text-3xl font-bold text-theme-logo-color">Settings</h1>
      </div>

      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-8 gap-4">
        <div className="flex flex-wrap gap-3">
          <TagComponent icon={<FaUserTie />} label="Seller" color="pink" />
          <TagComponent icon={<FaShoppingCart />} label="Buyer" color="green" />
        </div>
        <div className="flex flex-wrap gap-3">
          <TagComponent icon={<FaGlobe />} label="Web" color="green" />
          <TagComponent icon={<FaAndroid />} label="Android" color="green" />
        </div>
      </div>

      
      <p className="text-start mb-6 text-gray-600 ">
        The Selzor platform gives you full control to customize nearly every
        part of your product catalogue. The following options are available for
        Sellers.
      </p>

      {/* Seller Settings */}
      <div className=" text-start pb-4">
        <h2 className="text-xl font-semibold text-gray-800">Seller Settings</h2>
        <ul className="space-y-2 mt-4">
          <li>
            <a href="GeneralsSet" className="text-blue-500 hover:underline">
              General Settings
            </a>
          </li>
          <li>
            <a
              href="ProductAttributes"
              className="text-blue-500 hover:underline"
            >
              Product Attributes
            </a>
          </li>
          <li>
            <a href="ExportExcelData" className="text-blue-500 hover:underline">
              Excel Import & Print Order Settings
            </a>
          </li>
          <li>
            <a href="Badges" className="text-blue-500 hover:underline">
              Badges
            </a>
          </li>
          {/* <li>
            <a href="StockStatus" className="text-blue-500 hover:underline">
              Stock Status
            </a>
          </li> */}
          <li>
            <a href="Warehouses" className="text-blue-500 hover:underline">
              Warehouses
            </a>
          </li>
          {/* <li>
            <a href="Territories" className="text-blue-500 hover:underline">
              Territories
            </a>
          </li> */}
          {/* <li>
            <a
              href="CustomOrderFields"
              className="text-blue-500 hover:underline"
            >
              Custom Order Fields
            </a>
          </li> */}
        </ul>
      </div>

      {/* Buyer Settings */}
      <div className="text-start pb-4">
        <h2 className="text-xl font-semibold text-gray-800">Buyer Settings</h2>
        <ul className="space-y-2 mt-4">
          <li>
            <a href="GeneralsSet" className="text-blue-500 hover:underline">
              General Settings
            </a>
          </li>
          <li>
            <a href="/contact-us" className="text-gray-400">
              Contact Info
            </a>
          </li>
          <li>
            <a href="/" className="text-gray-400 ">
              Shipping Info
            </a>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Settings;
